import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Send } from "lucide-react";

export default function ContactForm() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [form, setForm] = React.useState({
        name: "",
        email: "",
        message: "",
    });
    const [errors, setErrors] = React.useState({});

    const validate = () => {
        const e = {};
        if (!form.name.trim() || form.name.trim().length < 2) {
            e.name = t("contact.form.errors.name");
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
            e.email = t("contact.form.errors.email");
        }
        if (!form.message.trim() || form.message.trim().length < 10) {
            e.message = t("contact.form.errors.message");
        }
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSubmit = (evt) => {
        evt.preventDefault();
        if (!validate()) return;
        // Frontend-only submission
        navigate("/thank_you");
    };

    const setField = (k) => (evt) =>
        setForm((f) => ({ ...f, [k]: evt.target.value }));

    return (
        <form
            onSubmit={handleSubmit}
            className="aurx-form"
            noValidate
            data-testid="contact-form"
        >
            <div className="aurx-field">
                <label htmlFor="contact-name">
                    {t("contact.form.name_label")}
                </label>
                <input
                    id="contact-name"
                    name="name"
                    type="text"
                    autoComplete="name"
                    placeholder={t("contact.form.name_placeholder")}
                    value={form.name}
                    onChange={setField("name")}
                    data-testid="form-name"
                />
                {errors.name && (
                    <div className="aurx-error" data-testid="form-name-error">
                        {errors.name}
                    </div>
                )}
            </div>

            <div className="aurx-field">
                <label htmlFor="contact-email">
                    {t("contact.form.email_label")}
                </label>
                <input
                    id="contact-email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    placeholder={t("contact.form.email_placeholder")}
                    value={form.email}
                    onChange={setField("email")}
                    data-testid="form-email"
                />
                {errors.email && (
                    <div className="aurx-error" data-testid="form-email-error">
                        {errors.email}
                    </div>
                )}
            </div>

            <div className="aurx-field">
                <label htmlFor="contact-message">
                    {t("contact.form.message_label")}
                </label>
                <textarea
                    id="contact-message"
                    name="message"
                    placeholder={t("contact.form.message_placeholder")}
                    value={form.message}
                    onChange={setField("message")}
                    data-testid="form-message"
                />
                {errors.message && (
                    <div
                        className="aurx-error"
                        data-testid="form-message-error"
                    >
                        {errors.message}
                    </div>
                )}
            </div>

            <p
                style={{
                    fontSize: 12,
                    color: "var(--stone)",
                    marginBottom: 20,
                }}
            >
                {t("contact.form.consent")}
            </p>

            <button
                type="submit"
                className="aurx-btn aurx-btn-primary"
                data-testid="form-submit"
            >
                {t("contact.form.submit")}
                <Send size={16} />
            </button>
        </form>
    );
}
